var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcUpdateProfilePic = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  viewBox: "0 0 60 60",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3f68b5;}.a,.d{stroke:#fff;}.b,.c,.d{fill:none;}.d{stroke-width:1.5px;}.e,.f{stroke:none;}.f{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-767 -626)"
}, /*#__PURE__*/React.createElement("g", {
  className: "a",
  transform: "translate(767 626)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "e",
  cx: 30,
  cy: 30,
  r: 30
}), /*#__PURE__*/React.createElement("circle", {
  className: "b",
  cx: 30,
  cy: 30,
  r: 29.5
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(282 518)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 40,
  height: 40,
  transform: "translate(495 118)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(498.529 126.235)"
}, /*#__PURE__*/React.createElement("g", {
  className: "c",
  transform: "translate(0 7.907)"
}, /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M2.239-4.367h1.53v-1.4H7.245v1.4H9.11l2.107-3.541h9.257l2.464,3.541h6.614a2.239,2.239,0,0,1,2.239,2.239V12.649a2.239,2.239,0,0,1-2.239,2.239H2.239A2.239,2.239,0,0,1,0,12.649V-2.128A2.239,2.239,0,0,1,2.239-4.367Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M 12.07001495361328 -6.407224178314209 L 9.962739944458008 -2.866544246673584 L 5.744680404663086 -2.866544246673584 L 5.744680404663086 -4.262954235076904 L 5.268440246582031 -4.262954235076904 L 5.268440246582031 -2.866544246673584 L 2.238889694213867 -2.866544246673584 C 1.831460952758789 -2.866544246673584 1.5 -2.535073757171631 1.5 -2.127644062042236 L 1.5 12.64904594421387 C 1.5 13.05647659301758 1.831460952758789 13.38793563842773 2.238889694213867 13.38793563842773 L 29.55339050292969 13.38793563842773 C 29.96081924438477 13.38793563842773 30.29228019714355 13.05647659301758 30.29228019714355 12.64904594421387 L 30.29228019714355 -2.127644062042236 C 30.29228019714355 -2.535073757171631 29.96081924438477 -2.866544246673584 29.55339050292969 -2.866544246673584 L 22.15542984008789 -2.866544246673584 L 19.69097900390625 -6.407224178314209 L 12.07001495361328 -6.407224178314209 M 11.21719932556152 -7.907224178314209 L 20.4744987487793 -7.907224178314209 L 22.93894958496094 -4.366544246673584 L 29.55339050292969 -4.366544246673584 C 30.78989028930664 -4.366544246673584 31.79228019714355 -3.364153385162354 31.79228019714355 -2.127644062042236 L 31.79228019714355 12.64904594421387 C 31.79228019714355 13.8855562210083 30.78989028930664 14.88793563842773 29.55339050292969 14.88793563842773 L 2.238889694213867 14.88793563842773 C 1.002389907836914 14.88793563842773 0 13.8855562210083 0 12.64904594421387 L 0 -2.127644062042236 C 0 -3.364153385162354 1.002389907836914 -4.366544246673584 2.238889694213867 -4.366544246673584 L 3.768440246582031 -4.366544246673584 L 3.768440246582031 -5.762954235076904 L 7.244680404663086 -5.762954235076904 L 7.244680404663086 -4.366544246673584 L 9.109920501708984 -4.366544246673584 L 11.21719932556152 -7.907224178314209 Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "d",
  transform: "translate(10.292 7.099)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "e",
  cx: 5.711,
  cy: 5.711,
  r: 5.711
}), /*#__PURE__*/React.createElement("circle", {
  className: "b",
  cx: 5.711,
  cy: 5.711,
  r: 4.961
})), /*#__PURE__*/React.createElement("g", {
  className: "d",
  transform: "translate(25.811 7.131)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "e",
  cx: 1.032,
  cy: 1.032,
  r: 1.032
}), /*#__PURE__*/React.createElement("circle", {
  className: "b",
  cx: 1.032,
  cy: 1.032,
  r: 0.282
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcUpdateProfilePic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_update_profile_pic.2b8c0461ea2cf7adb1164d425af2907f.svg";